import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Subscription } from 'rxjs';
import { ExpectedDateTime } from '../../interfaces/order-form-data.interface';

@Directive()
export abstract class FormStepAbstract implements ControlValueAccessor, Validator, OnInit, OnDestroy {
  @Input() isError: boolean = false;
  isEmitEvent: boolean = true;

  form: FormGroup | FormControl<any>;
  valueChangeSub: Subscription;

  private isFirstWrite: boolean = true;

  public errorStateMatcher: ErrorStateMatcher = {
    isErrorState: (ctrl): boolean => {
      if(!ctrl) {
        return false;
      }

      return ctrl.invalid && (ctrl.dirty || ctrl.touched || this.isError);
    }
  };

  setIsEminEvent(state: boolean): void {
    this.isEmitEvent = state;
  }

  ngOnInit(): void {
    this.valueChangeSub = this.form.valueChanges.subscribe(() => {
      this.onChange(this.getFormData());
    });
  }

  ngOnDestroy(): void {
    this.valueChangeSub?.unsubscribe();
  }

  onChange: any = () => {
  };
  onTouched: any = () => {
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onChange(this.getFormData());
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.form.disable() : this.form.enable();
  }

  writeValue(obj: any): void {
    if(obj === null && !this.isFirstWrite) {
      this.form.reset();
    }
    this.isFirstWrite = false;

    if(obj) {
      this.form.patchValue(obj, {emitEvent: this.isEmitEvent});
    }

    this.isFirstWrite = false;
    this.setIsEminEvent(true);
  }

  validate(control: AbstractControl<ExpectedDateTime>): ValidationErrors | null {
    return this.form.valid ? null : {error: 'error'};
  }

  protected getFormData(): any {
    return this.form.getRawValue();
  }
}
